import React, { useState, useEffect } from "react"
import { Table, Button, Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link, useParams } from "react-router-dom"

const EditMaterialCategory = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [category, setCategory] = useState([])

  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = async () => {
    const resp = await api.get("category/" + id)
    setCategory(resp.data.data[0])
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    const response = await api.put("update-category/" + id, values)
    if (response.data.success === true) setSubmitted(true)
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }
  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Add Material Category</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/materials" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal mt-4"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
            }}
          >
            <Row>
              <div className="mb-3">
                <AvField
                  name="materialCategory"
                  label="Material Category"
                  value={category.materialCategory}
                  className="form-control"
                  type="text"
                  required
                />
              </div>
            </Row>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Category is Added!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Updating...</span>
                    </>
                  ) : (
                    <span>Update Category </span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditMaterialCategory
